import { useEffect, useState } from 'react'
import type { SideChatPosition } from './useSideChatPosition'

interface SideChatResizeHandleProps {
  position: SideChatPosition
  onResize: (width?: number, height?: number) => void
}

export default function SideChatResizeHandle({ position, onResize }: SideChatResizeHandleProps) {
  const [isDragging, setIsDragging] = useState(false)
  const [startPos, setStartPos] = useState({ x: 0, y: 0 })

  const isHorizontal = position === 'bottom'

  useEffect(() => {
    if (!isDragging) return

    const handleMouseMove = (e: MouseEvent) => {
      if (position === 'right') {
        onResize(Math.max(250, window.innerWidth - e.clientX - 20))
      } else if (position === 'left') {
        onResize(Math.max(250, e.clientX - 20))
      } else if (position === 'bottom') {
        onResize(undefined, Math.max(200, window.innerHeight - e.clientY - 20))
      }
    }

    const handleMouseUp = () => {
      setIsDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging, startPos, position, onResize])

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true)
    setStartPos({ x: e.clientX, y: e.clientY })
  }

  const style: React.CSSProperties = isHorizontal
    ? {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        cursor: 'row-resize',
        background: isDragging ? 'rgba(129, 140, 248, 0.3)' : 'transparent',
        transition: 'background 0.1s',
      }
    : {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '4px',
        cursor: 'col-resize',
        background: isDragging ? 'rgba(129, 140, 248, 0.3)' : 'transparent',
        transition: 'background 0.1s',
        ...(position === 'right' ? { left: 0 } : { right: 0 }),
      }

  return <div style={style} onMouseDown={handleMouseDown} />
}
